import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Sidebar from "src/components/common/Sidebar";
import {
  useAppEventGameListSelector,
  useAppPerformanceListSelector,
  useAppRodeoEventSettingsSelector,
} from "src/_common/hooks/selectors/eventSelector";
// import { useAppPerformanceInfoSelector, useAppPerformanceListSelector, useAppRodeoEventSettingsSelector } from "src/_common/hooks/selectors/eventSelector";
import { CRYPTO_SECRET_KEY, RODEO_PAGE_NAME, URLS } from "src/_config";
import Sponsor from "src/components/common/Sponsor";
import moment from "moment";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function ChallengeListPage() {
  const history = useHistory();
  const { eventId, performanceId } = useParams<any>();
  const eventApi = useEventApi();
  const [challengeList, setChallengeList] = useState<any>();
  const performanceList = useAppPerformanceListSelector();

  const getChallengeList = () => {
    let params = {
      rodeo_event_id: cryptr.decrypt(eventId),
      performance_id: cryptr.decrypt(performanceId),
    };
    eventApi.callGetChallengeList(
      params,
      (message: any, resp: any) => {
        console.log({ resp });
        setChallengeList(resp);
      },
      (message: any) => {
        // toast.error(message);
      }
    );
  };

  useEffect(() => {
    getChallengeList();
  }, []);

  return (
    <React.Fragment>
      <div className="main-content-panel">
        <div className="team-list-panel pt-3">
          <div className="d-flex justify-content-between align-items-center team-list-title-panel gap-3">
            <div className="team-list-title">
              <h1>{performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.title}</h1>
            </div>
            <div className="team-list-date">
              <p>
                {performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.pdate
                  ? moment(performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.pdate).format(
                      "MMM DD, YYYY"
                    )
                  : ""}
              </p>
            </div>
          </div>
        </div>
        <div className="main-content-header">
          <div className="main-content-title d-flex justify-content-space-between">
            <h1 className="challenge-header-text">Challenges</h1>
            <Link
              to={"/create-challenge/" + eventId + "/" + performanceId}
              className="small-btn"
              style={{ width: "41%", textAlign: "center" }}
            >
              Create Challenge
            </Link>
          </div>
        </div>
        <ul className="challenge-list">
          {challengeList?.length ? (
            challengeList?.map((item: any) => (
              <li key={item.id}>
                <Link to={"/challenge/" + eventId + "/" + performanceId + "/" + cryptr.encrypt(item.id)}>
                  <div className="col-left">{item?.home_user_details?.display_name}</div>
                  <div className="col-center">
                    <span>Vs</span>
                  </div>
                  <div className="col-right">
                    {item?.away_user_details ? (
                      item?.away_user_details?.display_name
                    ) : (
                      <span style={{ color: "var(--secondary-color)" }}>No opponent</span>
                    )}
                  </div>
                </Link>
              </li>
            ))
          ) : (
            <div className={"events-list-block d-flex align-items-center"}>
              <div className="team-list-content">
                <h4>No challenge available</h4>
              </div>
            </div>
          )}
        </ul>
      </div>
      <Sponsor />
    </React.Fragment>
  );
}
